import { render } from "./HistoryReview.vue?vue&type=template&id=6111c8bc&scoped=true"
import script from "./HistoryReview.vue?vue&type=script&lang=js"
export * from "./HistoryReview.vue?vue&type=script&lang=js"

import "./HistoryReview.vue?vue&type=style&index=0&id=6111c8bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6111c8bc"]])

export default __exports__